<template>
  <div class="d-inline-flex w-75 mb-1">
    <v-row>
      <v-col>
        <v-card rounded="30" elevation="6">
          <v-breadcrumbs class="font-weight-bold" style="font-size: 16px" :items="pageTitles">
            <template v-slot:prepend>
              <v-icon size="small" :icon="titleIcon"></v-icon>
            </template>
          </v-breadcrumbs>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  props: ["titles", "icon"],
  computed: {
    pageTitles() {
      return this.titles;
    },
    titleIcon() {
      return this.icon;
    },
  },
};
</script>
